import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { data } from 'jquery';
import { ServiceService } from '../service.service';
import { Notification } from '../../../core/Notifications/Notification';
import { Router } from '@angular/router';


@Component({
  selector: 'app-records',
  templateUrl: './records.component.html',
  styleUrls: ['./records.component.scss']
})
export class RecordsComponent implements OnInit {

  // public imagePath;
  // imgURL: any;
  // public message: string;

  // preview(files) {
  //   if (files.length === 0)
  //     return;

  //   var mimeType = files[0].type;
  //   if (mimeType.match(/image,file\/*/) == null) {
  //     this.message = "Only images are supported.";
  //     return;
  //   }

  //   var reader = new FileReader();
  //   this.imagePath = files;
  //   reader.readAsDataURL(files[0]); 
  //   reader.onload = (_event) => { 
  //     this.imgURL = reader.result; 
  //   }
  // }
  title = 'Upload Multiple Files in Angular 4';
  myFiles: string[] = [];
  sMsg: string = '';
  selectedFiles: any;
  base64Image: any;
  Image_Url;
  imageURL: string;
  fileURL: any;
  uploadForm: FormGroup;
  previousRecordForm: FormGroup;
  document: any;
  Test1: any;
  capturedImage: string | null = null;
  isCameraOpen = false;
  uploadTypes = [
    { id: 'document', name: 'Choose File' },
    { id: 'scanner', name: 'Scan Document' }
  ];

  @ViewChild('video', { static: false }) video: ElementRef;
  
  @ViewChild('multiUserSearch4') multiUserSearchInput4: ElementRef;
  Id: any;
  patient: any;
  filteredPatient: any;
  constructor(public formBuilder: FormBuilder, private router: Router, private domSanitizer: DomSanitizer, private service: ServiceService, private notify: Notification) {
    this.previousRecordForm = this.formBuilder.group({
      'PR_Id_FK':[''],
      'Doc_Id': [''],
      'Doc_Type': [''],
      'documentname': ['', [Validators.pattern("^\\S{0}.{0,24}\\S{1}$"), this.nameValidatorss]],
      'file': [''],
      'uploadType': ['']
    });
  }

  ngOnInit(): void {
    this.get_documenttype();
    this.Get_Paitentprofile();
    // this.get_patientdd(this.Id);
  }
 

  get_documenttype() {
    this.service.Get_documentdropdown()
      .subscribe((data) => {
        this.document = data
        console.log(this.document)
        console.log(this.document[2].doctype_name);
      })
  }

  Get_Paitentprofile() {
    this.service.Get_Paitentprofile()
      .subscribe((data) => {
        this.patient = data
        // this.filteredPatient = this.patient;
      })
  }

  onUploadTypeChange(selectedType: string) {
    if (selectedType === 'scanner') {
      this.previousRecordForm.get('Doc_Type')?.setValue(this.document[2]); // Automatically set to JPG
      this.previousRecordForm.get('Doc_Type')?.disable(); // Disable the field
    } else {
      this.previousRecordForm.get('Doc_Type')?.enable(); // Enable the field for document types
      this.previousRecordForm.get('Doc_Type')?.setValue(''); // Reset the value
    }
  this.isCameraOpen = false; // Close camera
  this.stopCamera(); // Stop the camera if it's open
  this.capturedImage = null;
  }
  private stopCamera() {
    if (this.video.nativeElement.srcObject) {
      this.video.nativeElement.srcObject.getTracks().forEach(track => track.stop());
    }
  }

  onSelectEvent(value: any) {
    const a = value;
    if (a != value) {
    }
    
    console.log(value);
  }


  nameValidatorss(control: any): { [key: string]: boolean } {
    const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?/\/,/0-9]/;
    if (control.value && nameRegexp.test(control.value)) {
      return { invalidName: true };
    }
  }

  onInputChange4() {
    const searchInput = this.multiUserSearchInput4.nativeElement.value.toLowerCase();

    // Filter doctors based on the search input
    this.filteredPatient = searchInput
      ? this.patient.filter(d => d.pR_Name.toLowerCase().includes(searchInput))
      : [...this.patient]; // Reset to original list if input is empty
  }

  // Reset search field and filtered doctors when focus is lost
onSearchFieldFocusOut() {
  this.multiUserSearchInput4.nativeElement.value = ''; // Clear search input
  this.filteredPatient = [...this.patient]; // Reset to original doctor list
}

  initCamera() {
    this.isCameraOpen = true; // Enable camera access
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
        this.video.nativeElement.srcObject = stream;
        this.video.nativeElement.play();
      });
    }
  }

  captureImage() {
    const stream = this.video.nativeElement.srcObject;
    if (this.video.nativeElement.videoWidth > 0 && this.video.nativeElement.videoHeight > 0) {
      const canvas = document.createElement('canvas');
      canvas.width = this.video.nativeElement.videoWidth;
      canvas.height = this.video.nativeElement.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(this.video.nativeElement, 0, 0, canvas.width, canvas.height);
      this.capturedImage = canvas.toDataURL('image/png');
    } else {
      console.error('Video not loaded or playing');
    }
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach(track => track.stop());
    }
    this.isCameraOpen = false;
    this.video.nativeElement.srcObject = null;
  }
  

  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }
  
  


  onSelectFile(fileInput: any) {
    this.selectedFiles = <File>fileInput.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(fileInput.target.files[0]);
      reader.onload = (event: any) => {
        this.base64Image = this.domSanitizer.bypassSecurityTrustUrl(event.target.result);
        this.Image_Url = this.base64Image
      };
        
  }

  save_document() {
  let doctype: string;
  let docTypeId: any;
  const selectedUploadType = this.previousRecordForm.value.uploadType;

  if (selectedUploadType === 'scanner') {
    doctype = "PNG"; 
    docTypeId = 2;
  } else {
    doctype = this.previousRecordForm.value.Doc_Type.doctype_name;
  }

  //  var tExt = this.previousRecordForm.value.file.split('.').pop();
  //   var typeExt=tExt.toUpperCase();
   
  // if (typeExt == 'PDF' || typeExt == 'PNG' || typeExt == 'JPG' || typeExt == 'JPEG') {
     
  //   if (doctype != typeExt)
  //   {
  //     this.notify.errorsmsg('Please select correct document type or choose correct file');
  //     return;
  //   }

  // }
  // else {
  //   this.notify.errorsmsg("Please choose correct file")
  //   return;
  // }
    const formData = new FormData();
    if (this.previousRecordForm.get('uploadType').value === 'scanner') {
      if (this.capturedImage) {
        const blob = this.dataURItoBlob(this.capturedImage);
        formData.append('Choose_Document', blob, 'captured-image.png');
      } else {
        this.notify.errorsmsg("Please capture an image before submitting.");
        return;
      }
    } else {
      formData.append('Choose_Document', this.selectedFiles);
       var tExt = this.previousRecordForm.value.file.split('.').pop();
    var typeExt=tExt.toUpperCase();
   
  if (typeExt == 'PDF' || typeExt == 'PNG' || typeExt == 'JPG' || typeExt == 'JPEG') {
     
    if (doctype != typeExt)
    {
      this.notify.errorsmsg('Please select correct document type or choose correct file');
      return;
    }

  }
  else {
    this.notify.errorsmsg("Please choose correct file")
    return;
  }
    }
  
    if (selectedUploadType === 'scanner') {
      formData.append('Doc_Type_Id_FK', docTypeId);
    } else {
      formData.append('Doc_Type_Id_FK', this.previousRecordForm.value.Doc_Type.doctype_id);
    }
  //   if (selectedUploadType === 'scanner') {
  //     const blob = this.dataURItoBlob(this.capturedImage);
  //     formData.append('Choose_Document', blob, 'capturedImage.png');
  // } else {
  //     formData.append('Choose_Document', this.selectedFiles);
  //   }
    formData.append('documentname', this.previousRecordForm.value.documentname);
    formData.append('PR_Id_FK', this.patient.Id);
    this.service.Insert_document(formData)
      .subscribe((data) => {
        this.notify.successmsg("Record Inserted Successfully")
        this.router.navigate(["/base/patient/previous-record"]);
        console.log('API Output', data)
      })
      

  }

}
